/**
 * eRCMS.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CaseStatus } from '../model/caseStatus';
import { GraphType } from '../model/graphType';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class StatisticsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param periodFrom 
     * @param periodTo 
     * @param locale 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public get(periodFrom?: Date, periodTo?: Date, locale?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public get(periodFrom?: Date, periodTo?: Date, locale?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public get(periodFrom?: Date, periodTo?: Date, locale?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public get(periodFrom?: Date, periodTo?: Date, locale?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (periodFrom !== undefined && periodFrom !== null) {
            queryParameters = queryParameters.set('periodFrom', <any>periodFrom.toISOString());
        }
        if (periodTo !== undefined && periodTo !== null) {
            queryParameters = queryParameters.set('periodTo', <any>periodTo.toISOString());
        }
        if (locale !== undefined && locale !== null) {
            queryParameters = queryParameters.set('locale', <any>locale);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/Statistics/GetCaseReportExcel`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param periodFrom 
     * @param periodTo 
     * @param locale 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBasicStatisticRawData(periodFrom?: Date, periodTo?: Date, locale?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getBasicStatisticRawData(periodFrom?: Date, periodTo?: Date, locale?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getBasicStatisticRawData(periodFrom?: Date, periodTo?: Date, locale?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getBasicStatisticRawData(periodFrom?: Date, periodTo?: Date, locale?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (periodFrom !== undefined && periodFrom !== null) {
            queryParameters = queryParameters.set('periodFrom', <any>periodFrom.toISOString());
        }
        if (periodTo !== undefined && periodTo !== null) {
            queryParameters = queryParameters.set('periodTo', <any>periodTo.toISOString());
        }
        if (locale !== undefined && locale !== null) {
            queryParameters = queryParameters.set('locale', <any>locale);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/Statistics/GetBasicStatisticsExcel`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param caseStatus 
     * @param countryCode 
     * @param isSentCases 
     * @param groupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCasesAmountPerStatus(caseStatus?: CaseStatus, countryCode?: string, isSentCases?: boolean, groupId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getCasesAmountPerStatus(caseStatus?: CaseStatus, countryCode?: string, isSentCases?: boolean, groupId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getCasesAmountPerStatus(caseStatus?: CaseStatus, countryCode?: string, isSentCases?: boolean, groupId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getCasesAmountPerStatus(caseStatus?: CaseStatus, countryCode?: string, isSentCases?: boolean, groupId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (caseStatus !== undefined && caseStatus !== null) {
            queryParameters = queryParameters.set('caseStatus', <any>caseStatus);
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = queryParameters.set('countryCode', <any>countryCode);
        }
        if (isSentCases !== undefined && isSentCases !== null) {
            queryParameters = queryParameters.set('isSentCases', <any>isSentCases);
        }
        if (groupId !== undefined && groupId !== null) {
            queryParameters = queryParameters.set('groupId', <any>groupId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/Statistics/casestatuscount`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param groupId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCasesAmountPerStatus_1(groupId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getCasesAmountPerStatus_1(groupId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getCasesAmountPerStatus_1(groupId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getCasesAmountPerStatus_1(groupId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (groupId === null || groupId === undefined) {
            throw new Error('Required parameter groupId was null or undefined when calling getCasesAmountPerStatus_1.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/Statistics/documentUploadCount/${encodeURIComponent(String(groupId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param graphType 
     * @param countryCode 
     * @param isSentCases 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getGraphParameters(graphType?: GraphType, countryCode?: string, isSentCases?: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getGraphParameters(graphType?: GraphType, countryCode?: string, isSentCases?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getGraphParameters(graphType?: GraphType, countryCode?: string, isSentCases?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getGraphParameters(graphType?: GraphType, countryCode?: string, isSentCases?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (graphType !== undefined && graphType !== null) {
            queryParameters = queryParameters.set('graphType', <any>graphType);
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = queryParameters.set('countryCode', <any>countryCode);
        }
        if (isSentCases !== undefined && isSentCases !== null) {
            queryParameters = queryParameters.set('isSentCases', <any>isSentCases);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/Statistics/graph`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
